<span class="m-2 float-right {{textClass}}">
        Gescots version {{version()}}
</span>
